import React, { useEffect } from "react"
import useLocalStorageState from "use-local-storage-state"
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom"
// import { Row } from "react-bootstrap"

export const Setup = () => {
    const [customer, setCustomer] = useLocalStorageState("customer")

    const navigate = useNavigate()

    useEffect(() => {
        if (customer?.customer_details?.user_type !== "1") {
            navigate("/dashboard")
        }
    }, [customer, navigate])

    const location = useLocation()
    const pathName = location.pathname

    const navItems = [
        {
            label: "Company Details",
            pathname: "/setup/companyDetails",
            icon: "bi bi-bank",
        },
        { label: "GST", pathname: "/setup/gst", icon: "bx bxs-receipt" },
        {
            label: "User Details",
            pathname: "/setup/userDetails",
            icon: "bx bxs-user",
        },
    ]

    return (
        // <Row>
        //   <Col></Col>
        // </Row>
        <div className="row d-flex" style={{ height: "100vh" }}>
            <div class="col-md-2 pt-3">
                {/* Sidebar */}
                <ul
                    className="p-0 mb-0 "
                    style={{
                        height: "100vh",
                        overflowY: "auto",
                        position: "sticky",
                        top: "81px",
                        height: "40%",
                    }}
                >
                    <div
                        className="d-flex flex-column text-start mt-0"
                        style={{ lineHeight: "0.85rem" }}
                    >
                        <h6
                            // className="addEnquiryHead"
                            style={{ fontWeight: "400", color: "black", fontSize: "1.13rem" }}
                        >
                            Setup
                        </h6>
                        <span
                            className="text-muted mb-1 small"
                            style={{ textWrap: "nowrap" }}
                        >
                            internal configurations here.
                        </span>
                        <hr
                            className="mt-2 mb-4"
                            style={{
                                borderTop: "0.5px solid #6c757d",
                                opacity: "0.3",
                            }}
                        />
                    </div>
                    {/* Sidebar Links */}
                    {navItems.map((item) => (
                        <li
                            key={item.pathname}
                            className="mb-2 rounded"
                            style={{ listStyle: "none" }}
                        >
                            <Link
                                to={item.pathname}
                                className={`d-block px-3 py-2 rounded text-decoration-none sidebar-link ${pathName === item.pathname
                                    ? "bg-brown text-white"
                                    : "bg-white text-dark"
                                    }`} p
                            >
                                <i className={`${item.icon} me-1`}></i> {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            {/* Main Content */}
            <div
                className=" p-3 col-md-10"
                style={{
                    borderLeft: "1px solid #dedede",
                    overflowY: "auto",
                }}
            >
                <Outlet />
            </div>

            {/* Custom Styles */}
            <style>
                {`
                .bg-white{
                    background-color:rgb(237 237 237 / 95%) !important;
                }
                .bg-brown {
                    background-color: #7a3a5e;
                }
    
                .sidebar-link {
                    transition: background-color 0.3s ease, color 0.3s ease;
                    font-size: 0.89rem;
                }
    
                .sidebar-link:hover {
                    background-color: #7a3a5e !important;
                    color: white !important;
                }
          `}
            </style>
        </div>
    )
}